﻿import { cheapEncryptPassToBase64 } from '../common/crypto';
import { LoginResponseModel } from '../services/axios/axios-api-generated';

interface STORAGE_KEYS {
    /** @deprecated */
    StorageUserModelKey: LoginResponseModel;
    StorageUsernameKey: string;
    DeviceIdKey: string;
    RefreshTokenKey: string;
}

class LocalStorageService {
    get<T extends keyof STORAGE_KEYS>(key: T): STORAGE_KEYS[T] | null {
        const str = localStorage.getItem(key);
        if (!str) {
            return null;
        }
        try {
            return JSON.parse(str) as T;
        } catch {
            return null;
        }
    }

    set<T extends keyof STORAGE_KEYS>(key: T, value: STORAGE_KEYS[T] | null): void {
        if (value === null) {
            this.remove(key);
        } else {
            localStorage.setItem(key, JSON.stringify(value));
        }
    }

    getWsPasscode(): string | null {
        return localStorage.getItem('PasswordCipherKey');
    }

    setWsPasscodeFromPassword(value: string) {
        localStorage.setItem('PasswordCipherKey', cheapEncryptPassToBase64(value));
    }

    setWsPasscodeRaw(value: string) {
        localStorage.setItem('PasswordCipherKey', value);
    }

    removeWsPasscode() {
        localStorage.removeItem('PasswordCipherKey');
    }

    remove(key: keyof STORAGE_KEYS) {
        localStorage.removeItem(key);
    }
}

export const localStorageService = new LocalStorageService();
